import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import styled from 'styled-components';

import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import Loader from 'components/Loader';

// Set the URL of the PDF file
const pdfUrl =
  'https://d31b0xt3oaqqjh.cloudfront.net/cms-documents/50b5385edb93446010e6fd5cd3bd47e77c601c93.pdf';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const StyledPDFContainer = styled.div`
  height: 100vh;
  overflow-x: auto; /* Enable horizontal scrolling */
  .react-pdf__Page__canvas {
    width: calc(100vw - 500px) !important;
    height: 100% !important;
    margin: auto;
  }
  @media (max-width: 768px) {
    .react-pdf__Page__canvas {
      width: calc(100vw - 16px) !important;
      height: 100% !important;
    }
    .react-pdf__Page__textContent {
      width: calc(100vw - 32px) !important;
      height: 100% !important;
      padding: 8px;
    }
  }
`;

const PDFViewer = ({ pdfFile }) => {
  const [numPages, setNumPages] = useState(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const renderPages = () => {
    const pages = [];
    for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
      pages.push(
        <Page
          key={pageNumber}
          pageNumber={pageNumber}
          width={window.innerWidth}
        />
      );
    }
    return pages;
  };
  return (
    <StyledPDFContainer>
      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<Loader />}
      >
        {renderPages()}
      </Document>
    </StyledPDFContainer>
  );
};

export default PDFViewer;
